<template>
  <div class="booking">
    <h1 class="sr-only">Öamtc Terminbuchung {{ getStepHeading() }}</h1>
    <div class="booking__container">
      <div class="booking__header">
        <button
          @click="headerClickHandler"
          title="Zurück"
          class="booking__header__button"
          role="button"
          aria-label="Zurück zur vorherigen Seite"
        >
          <IconChevronLeft aria-hidden="true" />
        </button>
        <span>Terminvergabe</span>
      </div>
      <hr class="booking__header__divider" />
      <Steps />
      <keep-alive>
        <component :is="stepDetails[activeStep - 1]?.component" />
      </keep-alive>
    </div>
    <ContactFAB />
  </div>
</template>

<script>
import Appointment from '@/components/Booking/Appointment.vue'
import ContactFAB from '@/components/Booking/ContactFAB.vue'
import Overview from '@/components/Booking/Overview.vue'
import Service from '@/components/Booking/Service.vue'
import Station from '@/components/Booking/Station.vue'
import Steps from '@/components/Booking/Steps.vue'
import Vehicle from '@/components/Booking/Vehicle.vue'
import IconChevronLeft from '@/components/icons/IconChevronLeft.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    IconChevronLeft,
    Steps,
    Service,
    Vehicle,
    Station,
    Appointment,
    Overview,
    ContactFAB,
  },
  computed: {
    ...mapGetters(['stepDetails', 'activeStep']),
  },
  methods: {
    headerClickHandler() {
      this.$store.commit('setActiveStep', this.activeStep - 1)
    },
    getStepHeading() {
      const stepDetails = this.stepDetails[this.activeStep - 1]
      if (!stepDetails || stepDetails === null) return ''

      return ' - Schritt ' + this.activeStep + ': ' + stepDetails.label
    },
  },
}
</script>

<style lang="scss">
.booking {
  @include flex-center-align;
  flex-direction: column;
  background-color: $color-grey-lightest;

  &__container {
    display: flex;
    flex-direction: column;
    background-color: white;
    border-radius: 4px;
    margin: 64px 0;
    max-width: 856px;
    padding: 32px 72px 40px;
    width: 100%;

    @media (max-width: 856px) {
      border-radius: 0;
      margin: 0;
    }

    @media (max-width: $breakpoint-max-tablet) {
      padding: 32px 32px 40px;
    }

    @media (max-width: $breakpoint-max-mobile) {
      padding: 0 16px 48px;
    }
  }

  &__header {
    display: none;
    cursor: pointer;
    font-weight: $font-weight-bold;
    text-align: center;
    padding: 16px 0;
    position: relative;
    grid-template-columns: 24px auto 24px;
    justify-items: center;
    align-items: center;

    @media (max-width: $breakpoint-max-mobile) {
      display: grid;
    }

    span {
      width: 100%;
    }

    &__button {
      background: none;
      border: none;
      cursor: pointer;
      padding: 0;

      &:focus {
        outline: none;
      }
    }

    &__divider {
      display: none;
      margin: 0 -16px;
      width: auto;

      @media (max-width: $breakpoint-max-mobile) {
        display: block;
      }
    }
  }
}
</style>
